import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { Menu } from 'primeng/menu';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { TransportService } from 'src/app/private/services/transport.service';
import { CreateTransportComponent } from "../../components/transport/create-transport/create-transport.component";
import { DeleteTransportComponent } from "../../components/transport/delete-transport/delete-transport.component";

@Component({
  selector: 'app-transport-configuration',
  imports: [ToolBarComponent, SharedModule, CreateTransportComponent, DeleteTransportComponent],
  templateUrl: './transport-configuration.component.html',
  styleUrl: './transport-configuration.component.scss'
})
export class TransportConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddTransport: boolean = false;
  editLeadFieldData: boolean = false;
  isEditTransport: boolean = false;
  isDeleteTransport: boolean = false;
  transportData: any;

  items: any[] = [];

  columns: any[] = [
    { field: 'route_name', header: 'Route Name' },
    { field: 'pickup_point', header: 'Pickup Point' },
    { field: 'drop_point', header: 'Drop Point' },
    { field: 'capacity', header: 'Capacity' },
    { field: 'fee_amount', header: 'Fee Amount', type:'fee_amount' },
    // { field: 'currency', header: 'Currency' },
    { field: 'facilities.vehicle_type', header: 'Vehicle Type' },
    { field: 'facilities.amenities', header: 'Amenities', type: 'array' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  constructor(
    private api: TransportService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  TransportActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Transport',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditTransport = true;
          }
        },
        {
          label: 'Delete Transport',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteTransport = true;
          }
        }
      ]
    }
  ]

  setTransportEditData(rowData: any) {
    this.transportData = rowData;
  }

  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"transport_category\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllTransportsWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load transports.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

  handleTransport() {
    this.isAddTransport = true;
  }

  handleCloseDialog() {
    this.isAddTransport = false;
  }

  // Helper method to get nested object value
  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((o, p) => o && o[p], obj);
  }
}
